import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AvailabilityModal from './AvailabilityModalConnector';

class BuyWithProInstallationButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
    };
  }

  toggleDisplay = () => {
    this.setState({ showModal: !this.state.showModal });
  };

  render() {
    return (
      <div>
        <button
          className="btn btn-secondary"
          type="submit"
          onClick={this.toggleDisplay}
          disabled={this.props.disabled}
        >
          <span className="desktop-only inline">{this.props.text}</span>
          <span className="tablet-mobile-only inline">{this.props.textMobile}</span>
        </button>
        <AvailabilityModal display={this.state.showModal} closeModal={this.toggleDisplay} />
      </div>
    );
  }
}

BuyWithProInstallationButton.propTypes = {
  disabled: PropTypes.bool,
  text: PropTypes.string.isRequired,
  textMobile: PropTypes.string.isRequired,
};

BuyWithProInstallationButton.defaultProps = {
  disabled: false,
};

export default BuyWithProInstallationButton;
